export const MonthlyReportSettings = {
  Role: "role" as const,
  IsEnabled: "isEnabled" as const,
}

export const CompanySettings = {
  Name: "name" as const,
  OrgNumber: "orgNumber" as const,
  Phone: "phone" as const,
  Mail: "mail" as const,
  VisitorCity: "visitorCity" as const,
  VisitorStreet1: "visitorStreet1" as const,
  VisitorStreet2: "visitorStreet2" as const,
  VisitorZipCode: "visitorZipCode" as const,
  BillingCity: "billingCity" as const,
  BillingStreet1: "billingStreet1" as const,
  BillingStreet2: "billingStreet2" as const,
  BillingZipCode: "billingZipCode" as const,
  VisitingCountryCode: "visitingCountryCode" as const,
  VisitingCountryName: "visitingCountryName" as const,
  BillingCountryCode: "billingCountryCode" as const,
  BillingCountryName: "billingCountryName" as const,
  CompanyImage: "companyImage" as const,
}

export const CustomerInvoiceSettings = {
  DefaultPaymentTerms: "defaultPaymentTerms" as const,
  InvoicePaymentOptions: "invoicePaymentOptions" as const,
  InvoiceIBAN: "invoiceIBAN" as const,
  InvoiceBIC: "invoiceBIC" as const,
  SendInvoiceFromId: "sendInvoiceFromId" as const,
  SendInvoiceFromName: "sendInvoiceFromName" as const,
  CompanyEmail: "companyEmail" as const,
  InvoiceTitleTemplate: "invoiceTitleTemplate" as const,
  InvoiceMessageTemplate: "invoiceMessageTemplate" as const,
  InvoiceFileNameTemplate: "invoiceFileNameTemplate" as const,
  ReminderCost: "reminderCost" as const,
  PenaltyInterestType: "penaltyInterestType" as const,
  PenaltyInterestPercentage: "penaltyInterestPercentage" as const,
  IsAutomaticRemindersEnabled: "isAutomaticRemindersEnabled" as const,
  AutomaticReminderDelay: "automaticReminderDelay" as const,
  AutomaticReminderAmountLimit: "automaticReminderAmountLimit" as const,
  AutomaticReminderPeriod: "automaticReminderPeriod" as const,
  AutomaticReminderCountLimit: "automaticReminderCountLimit" as const,
  InvoiceReminderNotesTemplate: "invoiceReminderNotesTemplate" as const,
  InvoiceReminderTitleTemplate: "invoiceReminderTitleTemplate" as const,
  InvoiceReminderMessageTemplate: "invoiceReminderMessageTemplate" as const,
  InvoiceReminderFileNameTemplate: "invoiceReminderFileNameTemplate" as const,
  DefaultInvoiceLayout: "defaultInvoiceLayout" as const,
  DefaultNotes: "defaultNotes" as const,
  HomePageUrl: "homePageUrl" as const,
  UseFTax: "useFTax" as const,
  HideDeliveryDate: "hideDeliveryDate" as const,
  Units: "units" as const,
  InvoiceSendType: "invoiceSendType" as const,
  InvoiceSendTypeName: "invoiceSendTypeName" as const,
  InvoiceReminderSendType: "invoiceReminderSendType" as const,
  InvoiceReminderSendTypeName: "invoiceReminderSendTypeName" as const,
}

export const PaymentOption = {
  Id: "id" as const,
  MethodId: "methodId" as const,
  MethodName: "methodName" as const,
  Number: "number" as const,
  IsDefault: "isDefault" as const,
}

export const InvoiceUnit = {
  Id: "id" as const,
  Name: "name" as const,
}

export const ProfileSettings = {
  Name: "name" as const,
  Mail: "mail" as const,
  OwnExpensePaymentMethods: "ownExpensePaymentMethods" as const,
  BankCardPaymentMethods: "bankCardPaymentMethods" as const,
  CreditCardPaymentMethods: "creditCardPaymentMethods" as const,
  CompanyCashPaymentMethods: "companyCashPaymentMethods" as const,
  SettlementPaymentMethods: "settlementPaymentMethods" as const,
  WintCardPaymentMethods: "wintCardPaymentMethods" as const,
  Phone: "phone" as const,
  IncludeOverdueInvoices: "includeOverdueInvoices" as const,
  NoDailyMailOnWeekends: "noDailyMailOnWeekends" as const,
  UseCompanySpecificEmail: "useCompanySpecificEmail" as const,
  CompanySpecificEmails: "companySpecificEmails" as const,
  ProfileImage: "profileImage" as const,
  TableSizeId: "tableSizeId" as const,
  TableSize: "tableSize" as const,
  TableSizeName: "tableSizeName" as const,
  LanguageKey: "languageKey" as const,
  LanguageName: "languageName" as const,
  BankAccount: "bankAccount" as const,
  BankAccountClearing: "bankAccountClearing" as const,
  AdditionalBankAccount: "additionalBankAccount" as const,
  AdditionalBankAccountClearing: "additionalBankAccountClearing" as const,
}

export const EmployeesSettings = {
  DeviationsViaMobile: "deviationsViaMobile" as const,
  DefaultSalaryDeviationPersonId: "defaultSalaryDeviationPersonId" as const,
  DefaultSalaryDeviationPersonName: "defaultSalaryDeviationPersonName" as const,
  Employees: "employees" as const,
  IsSalaryAdmin: "isSalaryAdmin" as const,
  SuperkollSalaryType: "superkollSalaryType" as const,
}

export const EmployeeSettings = {
  Name: "name" as const,
  Id: "id" as const,
  PersonNumber: "personNumber" as const,
  PersonNumberFormatted: "personNumberFormatted" as const,
  Phone: "phone" as const,
  Mail: "mail" as const,
  EmployeeImage: "employeeImage" as const,
  CEO: "cEO" as const,
  Contact: "contact" as const,
  Employee: "employee" as const,
  Documents: "documents" as const,
  IncomingInvoicesOverview: "incomingInvoicesOverview" as const,
  IncomingInvoices: "incomingInvoices" as const,
  InvoicesAdmin: "invoicesAdmin" as const,
  Invoices: "invoices" as const,
  ReceiptsAdmin: "receiptsAdmin" as const,
  Receipts: "receipts" as const,
  Admin: "admin" as const,
  Reports: "reports" as const,
  IncomingInvoicesAdmin: "incomingInvoicesAdmin" as const,
  IncomingInvoicesSignee: "incomingInvoicesSignee" as const,
  Agreement: "agreement" as const,
  CashReconciliation: "cashReconciliation" as const,
  PaymentFileSignee: "paymentFileSignee" as const,
  MissingDocumentAdmin: "missingDocumentAdmin" as const,
  UploadGenericDocuments: "uploadGenericDocuments" as const,
  Auditor: "auditor" as const,
  Revisor: "revisor" as const,
  SalaryAdmin: "salaryAdmin" as const,
  DeviationAdmin: "deviationAdmin" as const,
  PaymentSignee: "paymentSignee" as const,
  StoppedPaymentAdmin: "stoppedPaymentAdmin" as const,
  Advisor: "advisor" as const,
  Board: "board" as const,
  BankAccount: "bankAccount" as const,
  BankAccountClearing: "bankAccountClearing" as const,
  TaxTable: "taxTable" as const,
  TaxTableName: "taxTableName" as const,
  EmploymentStartDate: "employmentStartDate" as const,
  EmploymentEndDate: "employmentEndDate" as const,
  TerminationReason: "terminationReason" as const,
  TerminationReasonName: "terminationReasonName" as const,
  CanChangeTerminationReason: "canChangeTerminationReason" as const,
  MonthlySalary: "monthlySalary" as const,
  HourlySalary: "hourlySalary" as const,
  EmploymentRate: "employmentRate" as const,
  ScheduleDescription: "scheduleDescription" as const,
  Schedule: "schedule" as const,
  FutureSchedule: "futureSchedule" as const,
  FutureEmploymentRate: "futureEmploymentRate" as const,
  FutureUsualWorkHours: "futureUsualWorkHours" as const,
  ScheduleViewMode: "scheduleViewMode" as const,
  AdditionalBankAccount: "additionalBankAccount" as const,
  AdditionalBankAccountClearing: "additionalBankAccountClearing" as const,
  Assistants: "assistants" as const,
  QuickSelection: "quickSelection" as const,
  SalaryActive: "salaryActive" as const,
  SalaryActivated: "salaryActivated" as const,
  SalaryChangeFrom: "salaryChangeFrom" as const,
  WorkplaceStreetAddress: "workplaceStreetAddress" as const,
  WorkplaceCity: "workplaceCity" as const,
  EmploymentRateChangeFrom: "employmentRateChangeFrom" as const,
  IsTimeReportingMandatory: "isTimeReportingMandatory" as const,
  TimeReportingInterval: "timeReportingInterval" as const,
  TimeReportingIntervalName: "timeReportingIntervalName" as const,
  IncomingInvoiceReferenceNames: "incomingInvoiceReferenceNames" as const,
  BusinessUnitId: "businessUnitId" as const,
  BusinessUnitName: "businessUnitName" as const,
  Position: "position" as const,
  VacationConditions: "vacationConditions" as const,
  OccupationalCategorisationId: "occupationalCategorisationId" as const,
  OccupationalCategorisation: "occupationalCategorisation" as const,
  UsualWorkHours: "usualWorkHours" as const,
  SalaryCostCenter: "salaryCostCenter" as const,
  WintSalarySpecificSettings: "wintSalarySpecificSettings" as const,
  WintSalaryType: "wintSalaryType" as const,
  WintSalaryTypeDescription: "wintSalaryTypeDescription" as const,
  UserTypeId: "userTypeId" as const,
}

export const RemoveEmployee = {
  EmploymentEndDate: "employmentEndDate" as const,
}

export const DimensionGroup = {
  FieldName: "fieldName" as const,
  DimensionTypeId: "dimensionTypeId" as const,
  DimensionTypeName: "dimensionTypeName" as const,
  DimensionList: "dimensionList" as const,
}

export const StandardDimension = {
  Name: "name" as const,
  DimensionId: "dimensionId" as const,
  DimensionName: "dimensionName" as const,
  IsDemanded: "isDemanded" as const,
  Category: "category" as const,
}

export const StandardDimensionCategory = {
}

export const IntegrationSettings = {
  Apps: "apps" as const,
  CanSave: "canSave" as const,
}

export const IntegrationItem = {
  Name: "name" as const,
  AppCategory: "appCategory" as const,
  AppCategoryName: "appCategoryName" as const,
  Description: "description" as const,
  ImageSource: "imageSource" as const,
  IsActive: "isActive" as const,
  AppData: "appData" as const,
  ActivationState: "activationState" as const,
  DisplayOrder: "displayOrder" as const,
  StripeConnectAccountId: "stripeConnectAccountId" as const,
  StatusLabel: "statusLabel" as const,
  StatusDisplayType: "statusDisplayType" as const,
  StatusUnavailable: "statusUnavailable" as const,
  VismaAdvisorStatus: "vismaAdvisorStatus" as const,
  VismaAdvisorAgencyName: "vismaAdvisorAgencyName" as const,
}

export const BankBalanceSettings = {
  Accounts: "accounts" as const,
}

export const BankBalanceAccountSetting = {
  AccountId: "accountId" as const,
  AccountNumber: "accountNumber" as const,
  BankName: "bankName" as const,
  BankAccountNumber: "bankAccountNumber" as const,
  ShowOnDashboard: "showOnDashboard" as const,
}

export const SalarySettings = {
  SalarySettings: "salarySettings" as const,
}

export const SalarySetting = {
  Id: "id" as const,
  Name: "name" as const,
  BankAccount: "bankAccount" as const,
  BankAccountClearing: "bankAccountClearing" as const,
  MonthlySalary: "monthlySalary" as const,
  EmploymentRate: "employmentRate" as const,
  TaxTable: "taxTable" as const,
  TaxTableName: "taxTableName" as const,
  EmploymentStartDate: "employmentStartDate" as const,
  EmploymentEndDate: "employmentEndDate" as const,
  SalaryActive: "salaryActive" as const,
  SalaryChangeFrom: "salaryChangeFrom" as const,
  SalaryChanged: "salaryChanged" as const,
  WorkplaceStreetAddress: "workplaceStreetAddress" as const,
  WorkplaceCity: "workplaceCity" as const,
  SalaryActivated: "salaryActivated" as const,
  Position: "position" as const,
  VacationConditions: "vacationConditions" as const,
  WorkType: "workType" as const,
  UsualWorkHours: "usualWorkHours" as const,
  Schedule: "schedule" as const,
}

